import React from "react";
import { FaRocket, FaTags, FaFire } from "react-icons/fa";

const MarketingCenter = () => {
  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              {/* <h4 className="mb-0 fw-semibold">Dashboard</h4> */}
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Venton</a>
                </li>
                <li className="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
          </div>
        </div>
        {/* ========== Page Title End ========== */}
        {/* Start here.... */}
        <div className="row">
          <div className="container">
      {/* Page Title */}
      <div className="mb-4">
        <h3 className="fw-bold">Marketing Center</h3>
        <p className="text-muted">
          Promote your products and increase sales using marketing tools
        </p>
      </div>

      <div className="row g-4">
        {/* Boost Your Listing */}
        <div className="col-md-4">
          <div className="card shadow-sm h-100 border-0">
            <div className="card-body text-center">
              <div className="mb-3 text-primary fs-1">
                <FaRocket />
              </div>
              <h5 className="card-title fw-bold">Boost Your Listing</h5>
              <p className="card-text text-muted">
                Promote your products to appear at the top of search and
                category pages.
              </p>
              <button className="btn btn-outline-primary w-100">
                Boost Now
              </button>
            </div>
          </div>
        </div>

        {/* Discount & Promotion */}
        <div className="col-md-4">
          <div className="card shadow-sm h-100 border-0">
            <div className="card-body text-center">
              <div className="mb-3 text-success fs-1">
                <FaTags />
              </div>
              <h5 className="card-title fw-bold">Discount & Promotion</h5>
              <p className="card-text text-muted">
                Create attractive discounts, coupons, and special offers for
                customers.
              </p>
              <button className="btn btn-outline-success w-100">
                Create Offer
              </button>
            </div>
          </div>
        </div>

        {/* Super Hot Deal */}
        <div className="col-md-4">
          <div className="card shadow-sm h-100 border-0">
            <div className="card-body text-center">
              <div className="mb-3 text-danger fs-1">
                <FaFire />
              </div>
              <h5 className="card-title fw-bold">Super Hot Deal</h5>
              <p className="card-text text-muted">
                Feature your best products in hot deals to drive instant sales.
              </p>
              <button className="btn btn-outline-danger w-100">
                Activate Deal
              </button>
            </div>
          </div>
        </div>
      </div>
     </div>

    </div>
    </div>
      {/* End Container Fluid */}
      {/* ========== Footer Start ========== */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />
              <a href="" className="fw-bold footer-text" target="_blank">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
      {/* ========== Footer End ========== */}
    </div>
  );
};

export default MarketingCenter;
